import React, { useState } from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Grid, Box, Button, Divider } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextEditor from './TextEditor';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const AddPackageForm = () => {
	const [step, setStep] = useState('one');
	const handleStep = (val) => {
		setStep(val);
	};
	const handleFormSubmit = () => {};
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<Formik
			initialValues={{
				email: '',
				phone: '',
			}}
			onSubmit={handleFormSubmit}>
			{(formik) => {
				const { errors, setFieldValue } = formik;
				return (
					<Form>
						<div className='header' style={{ marginTop: 0 }}>
							<div className='progress-container'>
								<div className='progress-bar' id='progressBar'></div>
							</div>
						</div>
						<Box style={{ padding: 10 }}>
							<Box
								style={{
									boxShadow:
										'rgba(0, 0, 0, 0.06) 0px 3px 3px -2px, rgba(0, 0, 0, 0.04) 0px 3px 4px 0px, rgba(0, 0, 0, 0.04) 0px 1px 8px 0px',
									padding: 30,
									background: 'white',
								}}>
								<Box style={{ display: 'flex' }}>
									<Box
										onClick={() => handleStep('one')}
										style={{
											color: step === 'one' ? '#1677ff' : '',
											borderBottom: step === 'one' ? '2px solid #1677ff' : '',
											fontSize: 14,
											cursor: 'pointer',
										}}>
										Overview
									</Box>
									<Box
										onClick={() => handleStep('two')}
										ml={2}
										style={{
											color: step === 'two' ? '#1677ff' : '',
											borderBottom: step === 'two' ? '2px solid #1677ff' : '',
											fontSize: 14,
											cursor: 'pointer',
										}}>
										Hotel
									</Box>
									<Box
										onClick={() => handleStep('three')}
										ml={2}
										style={{
											color: step === 'three' ? '#1677ff' : '',
											borderBottom: step === 'three' ? '2px solid #1677ff' : '',
											fontSize: 14,
											cursor: 'pointer',
										}}>
										Speciallization
									</Box>
									<Box
										onClick={() => handleStep('four')}
										ml={2}
										style={{
											color: step === 'four' ? '#1677ff' : '',
											borderBottom: step === 'four' ? '2px solid #1677ff' : '',
											fontSize: 14,
											cursor: 'pointer',
										}}>
										Itinerary
									</Box>
									<Box
										onClick={() => handleStep('five')}
										ml={2}
										style={{
											color: step === 'five' ? '#1677ff' : '',
											borderBottom: step === 'five' ? '2px solid #1677ff' : '',
											fontSize: 14,
											cursor: 'pointer',
										}}>
										Tour Gallery
									</Box>
									<Box
										onClick={() => handleStep('six')}
										ml={2}
										style={{
											color: step === 'six' ? '#1677ff' : '',
											borderBottom: step === 'six' ? '2px solid #1677ff' : '',
											fontSize: 14,
											cursor: 'pointer',
										}}>
										Package Policy
									</Box>
								</Box>
								<Divider />
								{step === 'one' ? (
									<>
										<Grid
											container
											style={{ marginTop: 5, padding: 10 }}
											spacing={4}>
											<Grid item xs={12} lg={6}>
												<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
													Package Name*
												</span>
												<br></br>
												<Field
													name='email'
													type='text'
													placeHolder='Enter Package Name'
													style={{
														padding: 10,
														width: '100%',
														borderRadius: 5,
														border: errors?.email
															? '2px solid red'
															: '1px solid',
														marginTop: 10,
													}}
													inputProps={{
														style: { padding: 12 },
													}}
												/>
												<br />
												{errors?.email ? (
													<span style={{ color: 'red', fontSize: 12 }}>
														{errors?.email}
													</span>
												) : null}
											</Grid>
											<Grid item xs={12} lg={6}>
												<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
													Package Code*
												</span>
												<br></br>
												<Field
													name='email'
													type='text'
													placeHolder='Enter Package Code'
													style={{
														padding: 10,
														width: '100%',
														borderRadius: 5,
														border: errors?.email
															? '2px solid red'
															: '1px solid',
														marginTop: 10,
													}}
													inputProps={{
														style: { padding: 12 },
													}}
												/>
												<br />
												{errors?.email ? (
													<span style={{ color: 'red', fontSize: 12 }}>
														{errors?.email}
													</span>
												) : null}
											</Grid>
											<Grid item xs={12} lg={6}>
												<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
													Category
												</span>
												<br></br>
												<Field
													name='email'
													type='text'
													placeHolder='Category'
													style={{
														padding: 10,
														width: '100%',
														borderRadius: 5,
														border: errors?.email
															? '2px solid red'
															: '1px solid',
														marginTop: 10,
													}}
													inputProps={{
														style: { padding: 12 },
													}}
												/>
												<br />
												{errors?.email ? (
													<span style={{ color: 'red', fontSize: 12 }}>
														{errors?.email}
													</span>
												) : null}
											</Grid>
											<Grid item xs={12} lg={6}>
												<Grid container spacing={2}>
													<Grid item xs={6}>
														<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
															Valid From
														</span>
														<br></br>
														<Field
															name='email'
															type='date'
															placeHolder='Enter Agency Name'
															style={{
																padding: 10,
																width: '100%',
																borderRadius: 5,
																border: errors?.email
																	? '2px solid red'
																	: '1px solid',
																marginTop: 10,
															}}
															inputProps={{
																style: { padding: 12 },
															}}
														/>
														<br />
														{errors?.email ? (
															<span style={{ color: 'red', fontSize: 12 }}>
																{errors?.email}
															</span>
														) : null}
													</Grid>
													<Grid item xs={6}>
														<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
															Valid To
														</span>
														<br></br>
														<Field
															name='email'
															type='date'
															placeHolder='Enter Agency Name'
															style={{
																padding: 10,
																width: '100%',
																borderRadius: 5,
																border: errors?.email
																	? '2px solid red'
																	: '1px solid',
																marginTop: 10,
															}}
															inputProps={{
																style: { padding: 12 },
															}}
														/>
														<br />
														{errors?.email ? (
															<span style={{ color: 'red', fontSize: 12 }}>
																{errors?.email}
															</span>
														) : null}
													</Grid>
												</Grid>
											</Grid>
											<Grid item xs={12} lg={6}>
												<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
													No of Days
												</span>
												<br></br>
												<Box
													style={{
														display: 'flex',
														justifyContent: 'space-between',
													}}>
													<Field
														name='email'
														type='text'
														placeHolder='No of Days'
														style={{
															padding: 10,
															width: '80%',
															borderRadius: 5,
															border: errors?.email
																? '2px solid red'
																: '1px solid',
															// marginTop: 10,
														}}
														inputProps={{
															style: { padding: 12 },
														}}
													/>
													<br />
													{errors?.email ? (
														<span style={{ color: 'red', fontSize: 12 }}>
															{errors?.email}
														</span>
													) : null}
													<Button
														type='submit'
														style={{
															background: 'rgb(25, 118, 210)',
															color: 'white',
															// padding: 16,
															borderRadius: 5,
															marginLeft: 5,
														}}>
														Select Cities
													</Button>
												</Box>
												<Box>
													<span style={{ marginTop: 10 }}>Route Map</span>
													<table style={{ width: '100%', marginTop: 10 }}>
														<tbody>
															<tr>
																<td
																	style={{
																		padding: 5,
																		border: '1px solid lightblue',
																	}}>
																	SNo.
																</td>
																<td
																	style={{
																		padding: 5,
																		border: '1px solid lightblue',
																	}}>
																	City
																</td>
																<td
																	style={{
																		padding: 5,
																		border: '1px solid lightblue',
																	}}>
																	No of Days
																</td>
																<td
																	style={{
																		padding: 5,
																		border: '1px solid lightblue',
																	}}>
																	Action
																</td>
															</tr>
															<tr>
																<td
																	style={{
																		padding: 5,
																		border: '1px solid lightblue',
																	}}>
																	1
																</td>
																<td
																	style={{
																		padding: 5,
																		border: '1px solid lightblue',
																	}}>
																	Dhanbad
																</td>
																<td
																	style={{
																		padding: 5,
																		border: '1px solid lightblue',
																	}}>
																	1
																</td>
																<td
																	style={{
																		padding: 5,
																		border: '1px solid lightblue',
																	}}>
																	Action
																</td>
															</tr>
														</tbody>
													</table>
												</Box>
											</Grid>
											<Grid item xs={12} lg={6}>
												<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
													Thumb Image
												</span>
												<br></br>
												<input
													type='file'
													style={{
														padding: 10,
														width: '100%',
														borderRadius: 5,
														border: errors?.email
															? '2px solid red'
															: '1px solid',
														// marginTop: 10,
													}}
												/>
											</Grid>
											<Grid item xs={12} lg={12}>
												<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
													Package Included
												</span>
												<FormGroup style={{ display: 'flex' }}>
													<FormControlLabel
														control={<Checkbox defaultChecked />}
														label='Flight'
													/>
													<FormControlLabel
														control={<Checkbox />}
														label='Hotel Stay'
													/>
													<FormControlLabel
														control={<Checkbox />}
														label='Meals'
													/>
													<FormControlLabel
														control={<Checkbox />}
														label='Transfer'
													/>
													<FormControlLabel
														control={<Checkbox />}
														label='Sightseeing'
													/>
													<FormControlLabel
														control={<Checkbox />}
														label='Cruise'
													/>
												</FormGroup>
											</Grid>
											<Grid item xs={12} lg={3}>
												<Button
													type='submit'
													style={{
														background: 'rgb(25, 118, 210)',
														color: 'white',
														marginTop: 30,
														// padding: 16,
														borderRadius: 5,
														width: '100%',
													}}>
													Next
												</Button>
											</Grid>
										</Grid>
									</>
								) : step === 'three' ? (
									<>
										<Grid
											container
											style={{ marginTop: 5, padding: 10 }}
											spacing={4}>
											<Grid item xs={12} lg={6}>
												<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
													Currency
												</span>
												<br></br>
												<Field
													name='email'
													type='text'
													placeHolder='Enter Package Name'
													style={{
														padding: 10,
														width: '100%',
														borderRadius: 5,
														border: errors?.email
															? '2px solid red'
															: '1px solid',
														marginTop: 10,
													}}
													inputProps={{
														style: { padding: 12 },
													}}
												/>
												<br />
												{errors?.email ? (
													<span style={{ color: 'red', fontSize: 12 }}>
														{errors?.email}
													</span>
												) : null}
											</Grid>
											<Grid item xs={12} lg={6}>
												<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
													Price Type
												</span>
												<br></br>
												<Field
													name='email'
													type='text'
													placeHolder='Enter Package Code'
													style={{
														padding: 10,
														width: '100%',
														borderRadius: 5,
														border: errors?.email
															? '2px solid red'
															: '1px solid',
														marginTop: 10,
													}}
													inputProps={{
														style: { padding: 12 },
													}}
												/>
												<br />
												{errors?.email ? (
													<span style={{ color: 'red', fontSize: 12 }}>
														{errors?.email}
													</span>
												) : null}
											</Grid>
											<Grid item xs={12} lg={6}>
												<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
													Price
												</span>
												<br></br>
												<Field
													name='email'
													type='text'
													placeHolder='Category'
													style={{
														padding: 10,
														width: '100%',
														borderRadius: 5,
														border: errors?.email
															? '2px solid red'
															: '1px solid',
														marginTop: 10,
													}}
													inputProps={{
														style: { padding: 12 },
													}}
												/>
												<br />
												{errors?.email ? (
													<span style={{ color: 'red', fontSize: 12 }}>
														{errors?.email}
													</span>
												) : null}
											</Grid>
											<Grid item xs={12} lg={6}></Grid>
											<Grid item xs={12} lg={6}>
												<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
													Discount
												</span>
												<br></br>
												<Field
													name='email'
													type='text'
													placeHolder='Category'
													style={{
														padding: 10,
														width: '100%',
														borderRadius: 5,
														border: errors?.email
															? '2px solid red'
															: '1px solid',
														marginTop: 10,
													}}
													inputProps={{
														style: { padding: 12 },
													}}
												/>
												<br />
												{errors?.email ? (
													<span style={{ color: 'red', fontSize: 12 }}>
														{errors?.email}
													</span>
												) : null}
											</Grid>
											<Grid item xs={12} lg={6}></Grid>
											<Grid item xs={12} lg={6}>
												<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
													Tax
												</span>
												<br></br>
												<Field
													name='email'
													type='text'
													placeHolder='Category'
													style={{
														padding: 10,
														width: '100%',
														borderRadius: 5,
														border: errors?.email
															? '2px solid red'
															: '1px solid',
														marginTop: 10,
													}}
													inputProps={{
														style: { padding: 12 },
													}}
												/>
												<br />
												{errors?.email ? (
													<span style={{ color: 'red', fontSize: 12 }}>
														{errors?.email}
													</span>
												) : null}
											</Grid>
											<Grid item xs={12} lg={12}>
												<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
													Package Included
												</span>
												<FormGroup style={{ display: 'flex' }}>
													<FormControlLabel
														control={<Checkbox defaultChecked />}
														label='Beach Holidays'
													/>
													<FormControlLabel
														control={<Checkbox />}
														label='Pilgrim Holidays'
													/>
													<FormControlLabel
														control={<Checkbox />}
														label='Hill Station Holidays'
													/>
													<FormControlLabel
														control={<Checkbox />}
														label='Adventure Holidays'
													/>
													<FormControlLabel
														control={<Checkbox />}
														label='Family Holidays'
													/>
													<FormControlLabel
														control={<Checkbox />}
														label='Honeymoon Holidays'
													/>
												</FormGroup>
											</Grid>
											<Grid item xs={12} lg={3}>
												<Button
													type='submit'
													style={{
														background: 'rgb(25, 118, 210)',
														color: 'white',
														marginTop: 30,
														// padding: 16,
														borderRadius: 5,
														width: '100%',
													}}>
													Next
												</Button>
											</Grid>
										</Grid>
									</>
								) : step === 'four' ? (
									<>
										<Grid
											container
											style={{ marginTop: 5, padding: 10 }}
											spacing={4}>
											{Array.from(Array(5)).map((i) => {
												return (
													<Grid item xs={12} lg={12} style={{ marginTop: 20 }}>
														<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
															City : Dubai, Day # 1 Heading & Description
														</span>
														<br></br>
														<Field
															name='email'
															type='text'
															placeHolder='Enter Package Name'
															style={{
																padding: 10,
																width: '100%',
																borderRadius: 5,
																border: errors?.email
																	? '2px solid red'
																	: '1px solid',
																marginTop: 10,
															}}
															inputProps={{
																style: { padding: 12 },
															}}
														/>
														<br />
														{errors?.email ? (
															<span style={{ color: 'red', fontSize: 12 }}>
																{errors?.email}
															</span>
														) : null}
														<TextEditor />
													</Grid>
												);
											})}
										</Grid>
									</>
								) : step === 'five' ? (
									<>
										<Grid
											container
											style={{ marginTop: 5, padding: 10 }}
											spacing={4}
											alignItems={'center'}>
											{Array.from(Array(5)).map((i) => {
												return (
													<>
														<Grid item xs={12} lg={4} style={{}}>
															<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
																Image Name #1
															</span>
															<br></br>
															<Field
																name='email'
																type='text'
																placeHolder='Enter Package Name'
																style={{
																	padding: 10,
																	width: '100%',
																	borderRadius: 5,
																	border: errors?.email
																		? '2px solid red'
																		: '1px solid',
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
															<br />
															{errors?.email ? (
																<span style={{ color: 'red', fontSize: 12 }}>
																	{errors?.email}
																</span>
															) : null}
														</Grid>
														<Grid item xs={12} lg={4}>
															<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
																Image File*
															</span>
															<br></br>
															<input
																type='file'
																style={{
																	padding: 8,
																	width: '100%',
																	borderRadius: 5,
																	border: errors?.email
																		? '2px solid red'
																		: '1px solid',
																	// marginTop: 10,
																}}
															/>
														</Grid>
														<Grid item xs={12} lg={4}>
															<img
																src='https://backend.traviyo.com/Images/Packages/Amman_31/636716367228174416_temp.jpg'
																style={{ height: 100 }}
															/>
														</Grid>
													</>
												);
											})}
										</Grid>
									</>
								) : step === 'six' ? (
									<>
										<Grid
											container
											style={{ marginTop: 5, padding: 10 }}
											spacing={4}>
											{Array.from(Array(5)).map((i) => {
												return (
													<Grid item xs={12} lg={12} style={{ marginTop: 20 }}>
														<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
															Description
														</span>
														<br></br>
														{errors?.email ? (
															<span style={{ color: 'red', fontSize: 12 }}>
																{errors?.email}
															</span>
														) : null}
														<TextEditor />
													</Grid>
												);
											})}
										</Grid>
									</>
								) : (
									''
								)}
							</Box>
						</Box>
					</Form>
				);
			}}
		</Formik>
	);
};

export default AddPackageForm;
